export const EShapeActionValueTransformRotateType = wcardinal.ui.EShapeActionValueTransformRotateType;